function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M9.28 20.31c.17.48-.35.92-.79.66l-3.15-1.79c-.57-.33-.92-1.12-.8-1.76l.94-4.67c.11-.55.87-.6 1.06-.08l2.74 7.64zm9.38-1.13l-3.16 1.8c-.44.25-.96-.18-.79-.66l2.75-7.71c.19-.52.95-.47 1.06.08l.95 4.73c.11.64-.24 1.43-.81 1.76zM17.08 7.32c.24.3.31.7.18 1.06l-4.74 13.25c-.17.49-.86.49-1.03 0L6.75 8.39c-.13-.36-.06-.76.18-1.06l3.82-4.7c.69-.83 1.83-.83 2.53 0l3.8 4.69z"
})));